import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CSSScrollSnapCarousel = ({
  slides = [],
  className = '',
  height = 'medium',
  onSlideChange,
}) => {
  const scrollContainerRef = useRef(null);

  // Handle scroll events to update current slide
  const handleScroll = useCallback(() => {
    if (!scrollContainerRef.current || !onSlideChange) return;

    const container = scrollContainerRef.current;
    const { scrollLeft } = container;
    const slideWidth = container.clientWidth;
    const currentSlide = Math.round(scrollLeft / slideWidth);

    onSlideChange(currentSlide);
  }, [onSlideChange]);

  return (
    <div className={classNames('CSSScrollSnapCarousel', className)}>
      {/* Pure CSS Scroll-Snap Carousel */}
      <div
        ref={scrollContainerRef}
        className={classNames(
          'flex overflow-x-auto overflow-y-hidden w-full scroll-smooth snap-x snap-mandatory [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden',
          {
            'h-64': height === 'small',
            'h-96': height === 'medium',
          }
        )}
        onScroll={handleScroll}
      >
        {slides.map(({ key, slide }) => (
          <div key={key} className="flex-shrink-0 w-full h-full snap-start">
            {slide}
          </div>
        ))}
      </div>
    </div>
  );
};

CSSScrollSnapCarousel.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      slide: PropTypes.node.isRequired,
    })
  ).isRequired,
  className: PropTypes.string,
  height: PropTypes.oneOf(['small', 'medium']),
  onSlideChange: PropTypes.func,
};

export default CSSScrollSnapCarousel;
